<template>
  <header class="header">
    <div class="row">
      <div class="column">
        <LogoLink />
      </div>
    </div>
  </header>
</template>

<script>
import LogoLink from '../../components/common/LogoLink.vue'

export default {
  name: 'Header',
  components: {
    LogoLink
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  z-index: z(header);
  height: 73px;

  ::v-deep img {
    height: 73px;
    width: auto;
    padding: 16px;
  }
}
</style>